import { inject, Injectable, signal } from '@angular/core';
import { ApiService } from 'src/app/abstract-classes/api.service/api.service';
import { Design } from 'src/app/interfaces/design';
import { DesignCategory } from 'src/app/interfaces/design-category';
import { DesignsProviderService } from 'src/app/providers/designs/designs.provider.service';

@Injectable({
  providedIn: 'root'
})
export class DesignsService extends ApiService<Design, DesignsProviderService> {
  private designsProviderService = inject(DesignsProviderService);
  protected override get provider(): DesignsProviderService {
    return this.designsProviderService;
  }

  public categories = signal<DesignCategory[]>([]);

  override async cacheData(retailerIframeID: string | null) {
    await Promise.all([this.cacheCategories(retailerIframeID), super.cacheData(retailerIframeID)]);
  }

  async cacheCategories(retailerIframeID: string | null) {
    this.categories.set(await this.designsProviderService.getCategories(retailerIframeID));
  }

  async getCategories(retailerIframeID: string | null) {
    return this.designsProviderService.getCategories(retailerIframeID);
  }
}
